export const newEvent = {
	title: "Nuevo evento",
	modalTitle: "Agregar evento",
	form: {
		labelName: "Nombre:",
		labelBegin: "Inicio:",
		labelDescription: "Descripción:",
		eventPicture: "Foto del evento:",
		backgroundEventPicture: "Foto de portada del evento:",
		editButton: "Editar",
		addButton: "Agregar",
		cancel: "Cancelar",
		peopleCapacity: "Capacidad del evento",
		peopleCapacityTooltip: "Cantidad de personas que el evento puede albergar.",
	},
};
